import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import { Box, Typography, Tab, Tabs } from '@mui/material';
import { useMaterialUIController } from 'context';
import PropTypes from 'prop-types';
import logger from 'utils/logger';
import intl from 'react-intl-universal';

const propTypes = {
  title: PropTypes.string.isRequired,
  tabs: PropTypes.array.isRequired,
};

const log = logger.createLogger('SettingsTabLayout');

const SettingsLayout = ({ title, tabs }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const tabStyle = { color: darkMode ? 'white' : 'grey' };
  const [currentTab, setCurrentTab] = useState(0);

  const createTab = (label, index) => {
    return (
      <Tab
        key={index}
        label={label}
        id={`${title}-tab-${index}`}
        aria-controls={`${title}-tabpanel-${index}`}
      />
    );
  };

  return (
    <Box py={3} px={3} mt={3} mx={3}>
      <Box pl={1} mb={1} display="flex">
        <Typography variant="h3">{title}</Typography>
      </Box>
      {tabs.length > 0 ? (
        <>
          <Grid container direction="column" justifyContent="center">
            <Box>
              <Tabs
                style={tabStyle}
                value={currentTab}
                onChange={(_, newValue) => setCurrentTab(newValue)}
                aria-label={`${title} tabs`}>
                {tabs.map((tab, index) => createTab(tab.label, index))}
              </Tabs>
            </Box>
          </Grid>
          <Grid container justifyContent="center">
            <Box sx={{ p: 3, width: '100%' }}>{tabs[currentTab].component}</Box>
          </Grid>
        </>
      ) : (
        <Box sx={{ p: 3, width: '100%', textAlign: 'center' }}>
          <Typography variant="h6">
            {intl.get(
              'organization_settings_tab_layout_no_client_data_available'
            )}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

SettingsLayout.propTypes = propTypes;

export default SettingsLayout;
